import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'emirati-dirham',
  size: 24,
  node: [
    [
      'path',
      {
        d: 'M11 4a8 8 0 0 1 0 16H6.406A.4.4 0 0 1 6 19.594V4.406A.4.4 0 0 1 6.406 4z',
        key: '1vb4d1',
      },
    ],
    ['path', { d: 'M4 10h17', key: 'pjix64' }],
    ['path', { d: 'M4 14h17', key: '426kq0' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name EmiratiDirham
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEgNGE4IDggMCAwIDEgMCAxNkg2LjQwNkEuNC40IDAgMCAxIDYgMTkuNTk0VjQuNDA2QS40LjQgMCAwIDEgNi40MDYgNHoiIC8+CiAgPHBhdGggZD0iTTQgMTBoMTciIC8+CiAgPHBhdGggZD0iTTQgMTRoMTciIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/emirati-dirham
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EmiratiDirham = createLucideIcon(__iconData);

export default EmiratiDirham;
